import axios from "axios";
import Utils from "../utils/utils";

export const FETCH_ADMIN_REQUEST = "FETCH_ADMIN_REQUES";
export const FETCH_ADMIN_SUCCESS = "FETCH_ADMIN_SUCCESS";
export const FETCH_ADMIN_FAILURE = "FETCH_ADMIN_FAILURE";

const SERVER_URL = `${process.env.REACT_APP_SERVER_URL}`;

export const fetchAdminRequest = () => ({
  type: FETCH_ADMIN_REQUEST,
});

export const fetchAdminSuccess = (adminData) => ({
  type: FETCH_ADMIN_SUCCESS,
  payload: adminData,
});

export const fetchAdminFailure = (error) => ({
  type: FETCH_ADMIN_FAILURE,
  payload: error,
});

export const fetchAdminData = () => {
  return async (dispatch) => {
    dispatch(fetchAdminRequest());
    const user = Utils.getLoggedInUser();
    const token = Utils.getToken();
    if (!user || !token) {
      dispatch(fetchAdminFailure("User not logged in or token missing."));
      return;
    }

    try {
      const res = await axios.get(`${SERVER_URL}/admin/${user.userId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const admin = res.data;
      dispatch(fetchAdminSuccess(admin));
    } catch (error) {
      dispatch(fetchAdminFailure("Something went wrong " + error.message));
    }
  };
};
